import React from 'react';
import {Box, Typography} from '@mui/material';
import {useTheme} from '@mui/material/styles';

// Configuration i18next
import 'packages/common/locales/i18n';

export default function App() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
      }}
    >
      <Typography
        variant="h3"
        sx={{
          color: 'white',
          fontWeight: 600,
          letterSpacing: '-0.02em',
        }}
      >
        Brydge
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: 'rgba(255, 255, 255, 0.7)',
          mt: 1,
        }}
      >
        Widget Services
      </Typography>
    </Box>
  );
}
